const quantityElement = document.querySelector('.quantity-cart');
const btnToggle = document.querySelector('#menuHamburguer svg'),
	menuToggle = document.querySelector('.menu-responsive');
const header = document.querySelector('.header');

btnToggle.addEventListener('click', () => {
	menuToggle.classList.toggle('open');
	document.body.classList.toggle('no-scroll');
});

window.addEventListener('scroll', function () {
	if (window.scrollY > 130) {
		header.classList.add('header-sticky');
	} else {
		header.classList.remove('header-sticky');
	}
});